export default __webpack_public_path__ + "static/media/punching_bag.bb290344.gif";